export default __webpack_public_path__ + "5122df13e806f689fc1a413f096c7b4f.svg";